import { createContext } from 'react';

const NavigationContext = createContext({
  next: null,
  prev: null,
  disabled: false,
  refetch: () => {},
});

export default NavigationContext;
